import ActionTable from "./components/ActionTable";
import Translate from "./components/Translate";

export const colDefs = [

  {
    headerName: "Nom",
    field: "name",
  },
  {
    headerName: "Code",
    field: "code",
  },

  {
    field: 'Traduction',
    cellRenderer: Translate,
    cellRendererParams: (params: any) => {
      const rowData = params.data;
      return {
        id: `${rowData.id}`,
        name:`${rowData.name}`,
        code:`${rowData.code}`,
      };
    },
    filter: false,
  },

  {
    field: 'Actions',
    cellRenderer: ActionTable,
    cellRendererParams: (params: any) => {
      const rowData = params.data;
      return {
        id: `${rowData.id}`,
        code: `${rowData.code}`,
      };
    },
    filter: false,
  },
];

export const languages10Options = [
    { label: "Français", value: "fr" },
    { label: "Anglais", value: "en" },
    { label: "Espagnol", value: "es" },
    { label: "Arabe", value: "ar" },
    { label: "Allemand", value: "de" },
    { label: "Italien", value: "it" },
    { label: "Portugais", value: "pt" },
    { label: "Chinois (Mandarin)", value: "zh" },
    { label: "Breton", value: "br" },
    { label: "Occitan", value: "oc" },
  ]